<template>
    <el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="供应商等级" prop="code">

                        <el-select v-model="form.gysdj" clearable style="width: 100%" size="mini" placeholder="供应商等级">
                            <el-option label="良好" :value="1"></el-option>
                            <el-option label="及格" :value="2"></el-option>
                            <el-option label="差" :value="3"></el-option>
                        </el-select>
                    </el-form-item>

                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
// import { addBasicClassify, editBasicClassify, queryByParentId } from '@/api/basic/commodityClassification.js'
import { classAdd,classEdit,updategysdj,queryByParentId } from '@/api/gysmng/index.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    components:{
        Treeselect
    },
    data(){
        return {
            title: "",
            form: {},
            openDialog: false,
            optionMenus: [],
            rules: {
                code: [{ required: false, message: '请输入分类编码', trigger: 'blur' }],
                name: [{ required: false, message: '请输入分类名', trigger: 'blur' }],
                parentId: [{ required: false, message: '请输入上级分类', trigger: 'blur' }],
                status: [{ required: false, message: '请输入状态0为不启用；1为启用', trigger: 'blur' }],
            },
            parentClassProps: {
                lazy: true,
                checkStrictly: true,
                lazyLoad : async (node, resolve)=> {
                    const { level } = node;
                    let pId = 0
                    if(level < 1){
                        pId = 0;
                    }else{
                        pId = node.data.id;
                    }
                    const { data: res } = await queryByParentId({id:pId});
                    if (res.code == 0) {
                        let nodes = res.data || [];
                        nodes.forEach((no)=>{
                            no['value'] = no.id;
                            no['label'] = no.name;
                            if(level<1){
                                 no['label'] = '一级分类';
                            }
                            no['leaf'] = !no.existNextLevel;
                        })
                        resolve(nodes);
                    }
                }
            },
        }
    },
    methods:{

        /** 查询菜单下拉树结构 */
        getTreeselect() {
            let _this = this;
            _this.optionMenus = [];
            this.getMenuData((data)=>{
                _this.optionMenus.push(data[0]);
            })
        },
        // 表单重置
        reset: function () {
            this.form = {
                id: undefined,
                code: undefined,
                name: undefined,
                parentId: undefined,
                // status: 0,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    // return
                    if (_this.form.id != undefined) {
                        updategysdj({id:_this.form.id,gysdj:this.form.gysdj}).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
    },
}
</script>

<style lang="sass" scoped>

</style>

